export interface Phoneme {
  // The English IPA notation symbol for the phoneme.
  ipa: string;

  // The text in `example` to emphasize.
  emphasis: string;

  // A word in which the phoneme appears.
  example: string;
}

export const Consonants: Phoneme[] = [
  { ipa: "b", emphasis: "b", example: "bed" },
  { ipa: "d", emphasis: "d", example: "dig" },
  { ipa: "d͡ʒ", emphasis: "j", example: "jam" },
  { ipa: "ð", emphasis: "th", example: "the" },
  { ipa: "f", emphasis: "f", example: "fix" },
  { ipa: "ɡ", emphasis: "g", example: "gap" },
  { ipa: "h", emphasis: "h", example: "hat" },
  { ipa: "j", emphasis: "y", example: "yes" },
  { ipa: "k", emphasis: "c", example: "cat" },
  { ipa: "l", emphasis: "l", example: "let" },
  { ipa: "m", emphasis: "m", example: "mat" },
  { ipa: "n", emphasis: "n", example: "nap" },
  { ipa: "ŋ", emphasis: "ng", example: "ring" },
  { ipa: "p", emphasis: "p", example: "put" },
  { ipa: "ɹ", emphasis: "r", example: "red" },
  { ipa: "s", emphasis: "s", example: "see" },
  { ipa: "ʃ", emphasis: "sh", example: "ship" },
  { ipa: "t", emphasis: "t", example: "ten" },
  { ipa: "t͡ʃ", emphasis: "ch", example: "chat" },
  { ipa: "θ", emphasis: "th", example: "thin" },
  { ipa: "v", emphasis: "v", example: "vet" },
  { ipa: "w", emphasis: "w", example: "win" },
  { ipa: "z", emphasis: "z", example: "zero" },
  { ipa: "ʒ", emphasis: "s", example: "vision" },
];

export const Vowels: Phoneme[] = [
  { ipa: "ə", emphasis: "a", example: "ago" },
  { ipa: "ɚ", emphasis: "er", example: "over" },
  { ipa: "æ", emphasis: "a", example: "tap" },
  { ipa: "aɪ", emphasis: "i", example: "ice" },
  { ipa: "aʊ", emphasis: "ow", example: "cow" },
  { ipa: "ɑ", emphasis: "o", example: "fox" },
  { ipa: "e", emphasis: "a", example: "ace" },
  { ipa: "ɝ", emphasis: "ur", example: "fur" },
  { ipa: "ɛ", emphasis: "e", example: "bet" },
  { ipa: "i", emphasis: "ee", example: "bee" },
  { ipa: "ɪ", emphasis: "i", example: "kit" },
  { ipa: "oʊ", emphasis: "o", example: "go" },
  { ipa: "ɔ", emphasis: "aw", example: "law" },
  { ipa: "ɔɪ", emphasis: "oi", example: "oil" },
  { ipa: "u", emphasis: "oo", example: "too" },
  { ipa: "ʊ", emphasis: "oo", example: "foot" },
  { ipa: "ʌ", emphasis: "u", example: "cut" },
];
